// @flow
import React, { type ElementConfig } from 'react';

import LabelAndErrorFormGroup, {
  type Props as LabelAndErrorFormGroupProps,
} from '@rover/react-lib/components/utils/LabelAndErrorFormGroup';
import AsInput from '../../../components/utils/AsInput';

type AsInputRequiredProps = ElementConfig<typeof AsInput>;

export type Props = $Diff<AsInputRequiredProps, { children: * }>;

const Input = ({ inputRef, onChange, sensitive, className, ...props }: Props) => (
  <AsInput {...{ inputRef, onChange, sensitive, className }}>
    {inputProps => <input {...props} {...inputProps} />}
  </AsInput>
);
type InputProps = {
  ...LabelAndErrorFormGroupProps,
  ...Props,
};
export default (props: InputProps) => (
  // $FlowFixMe - could not easily decipher how to address the Flow types here as part of FE-3869
  <LabelAndErrorFormGroup {...props}>
    {/*  we need to explicitly rename ref back to inputRef here so AsInput can pass it to the actual component  */}
    {({ ref, ...rest }) => <Input {...rest} inputRef={ref} />}
  </LabelAndErrorFormGroup>
);

export { Input as UnwrappedInput };



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/Input/Input.jsx